import { Type } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import * as EduFilesActions from '../edu-file/edu-file.actions';

const fieldActionMap: Dictionary<Type<Action>> = {};

export class EduContentDataFieldActionFactory {
  /**
   * For a given field & data, return the appropriate 'Loaded' action containing the data.
   *
   * Example: field `"books"` with data `[{id: 1}]` returns `BooksLoaded({ books: [{id: 1}] })`
   */
  static getLoadedAction(eduContentId: number, field: string, fieldData: any, data?: any): Action {
    const fieldActionExceptions: Dictionary<(fieldData, responseData) => Action> = {
      eduFiles: (eduFiles) => new EduFilesActions.AddEduFilesForEduContent({ eduContentId, eduFiles }),
    };

    if (fieldActionExceptions[field]) {
      return fieldActionExceptions[field](fieldData, data);
    }

    const FieldLoaded = fieldActionMap[field];

    return (
      FieldLoaded &&
      new FieldLoaded({
        eduContentId,
        [field]: fieldData,
      })
    );
  }

  /**
   * For a given field & data, return the appropriate 'Upsert' action containing the data.
   *
   * Example: field `"books"` with data `[{id: 1}]` returns `UpsertBooks({ books: [{id: 1}] })`
   */
  static getUpsertAction(eduContentId: number, field: string, fieldData: any, data?: any): Action {
    const fieldActionExceptions: Dictionary<(fieldData, responseData) => Action> = {};

    if (fieldActionExceptions[field]) {
      return fieldActionExceptions[field](fieldData, data);
    }

    // const FieldUpsert = fieldUpsertActionMap[field];

    return null;
    /*
    return (
      FieldUpsert &&
      new FieldUpsert({
        eduContentId,
        [field]: data,
      })
    );
    */
  }
}
